import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CoreAdvantagesSection from './components/CoreAdvantagesSection';
import ProductServicesSection from './components/ProductServicesSection';
import UserReviewsSection from './components/UserReviewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqList } from '@/mocks/clsqData';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'clsq官方落地页',
  url: 'https://clsq.com',
  description: 'clsq是您值得信赖的首选品牌，本页全面介绍clsq的核心优势、产品服务、用户评价及常见问题。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://clsq.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'clsq',
  url: 'https://clsq.com',
  description: 'clsq是一家专注于智能解决方案与企业服务的科技品牌，致力于为各行业客户提供高品质的产品与服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-xxx-xxxx',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="clsq官方落地页 - clsq品牌核心介绍 | 值得信赖的首选品牌"
        description="clsq是您值得信赖的首选品牌，本页全面介绍clsq的核心优势、产品服务、用户评价及常见问题，帮助您快速了解clsq，做出最佳选择。立即探索clsq带来的全新体验与价值。"
        keywords="clsq,clsq官网,clsq是什么,clsq品牌介绍,clsq产品服务,clsq用户评价,clsq常见问题"
        canonicalUrl="https://clsq.com"
        schemaData={{ ...homeSchema, ...orgSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CoreAdvantagesSection />
          <ProductServicesSection />
          <UserReviewsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}